// extracted by mini-css-extract-plugin
export default {"chip":"LastActivityChip_chip__igmKK"};